import request from '@/sheep/request';


// 查询愿望列表
export const getWishesLaunch = async () => {
	return request({
		url: '/wish/wishes/launch/info',
		method: 'GET',
	});
}